// extracted by mini-css-extract-plugin
export var dataCell = "_q3-2";
export var dataRow = "_q3-0";
export var headerRow = "_q3-1";